module.exports = __webpack_public_path__ + "static/media/HO11.0da2192e.png";